module.exports = __webpack_public_path__ + "img/Slide11.b2b337d7.png";